import axios from "axios";
import NProgress from "nprogress";
import router from "@/router"; // make sure this path is correct

const API_URL = process.env.VUE_APP_APIADMINURL;

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  if (!config.silent) NProgress.start();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config?.silent) NProgress.done();

    if (
      response?.data?.success === false &&
      response?.data?.errors?.error_code === 1020
    ) {
      localStorage.removeItem("user");
      sessionStorage.removeItem("user");
      router.push("/login");
    }

    return response;
  },
  (error) => {
    if (!error.config?.silent) NProgress.done();

    if (error.response?.status === 401) {
      localStorage.removeItem("user");
      sessionStorage.removeItem("user");

      router.push("/login");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
